import React from "react";
import { Row, Col } from "react-bootstrap";
import { RBSModal } from "../../base/rbs_components/RBSModal.tsx";
import { RBSTextField } from "../../base/rbs_components/RBSTextField.tsx";
import { RBSDropdown } from "../../base/rbs_components/RBSDropdown.tsx";
import type { Portfolio } from "../../base/ui_general/GeneralInterfaces.tsx";
import { ValidationSchemes, LabelTextMessageTypes } from "../../base/Settings.tsx";
import { getLabelTextMessage } from "../../base/utils/GeneralUtilities.tsx";
import type { InputStateControl } from "../../base/utils/InputStateControl.tsx";
import type { UserLanguages } from "../../base/Settings.tsx";
import { PortfolioTypeEnum } from "../../base/Settings.tsx";

//TODO: There are places where the multi-language support is missing


/**
 * Props for the PortfolioDetailModal component.
 */
interface PortfolioDetailModalProps {
    /** Whether the modal is visible. */
    show: boolean;
    /** The portfolio to edit (if any). */
    portfolio?: Portfolio;
    /** Callback when submitting the modal form. */
    onSubmit: (portfolioInput: Partial<Portfolio>) => void;
    /** Callback when closing the modal. */
    onClose: () => void;
    /** Whether the current form state is valid. */
    isValid: boolean;
    /** State control for input fields. */
    inputStateControl: InputStateControl;
    /** The user's selected language. */
    user_language: UserLanguages;
}


export const PortfolioDetailModal: React.FC<PortfolioDetailModalProps> = (props) => {
    const { portfolio, inputStateControl, user_language } = props;

    const prefill = (key: keyof Portfolio): string => {
        if (portfolio && portfolio[key] !== undefined && portfolio[key] !== null) {
            return String(portfolio[key]);
        }
        return "";
    };

    const headerTitle = portfolio ? "Update Portfolio" : "Create New Portfolio";

    return (
        <RBSModal
            show={props.show}
            header_title={headerTitle}
            show_close_button
            onClose={props.onClose}
            primary_button_label={getLabelTextMessage(LabelTextMessageTypes.SUBMIT, user_language)}
            secondary_button_label={getLabelTextMessage(LabelTextMessageTypes.CANCEL, user_language)}
            onClickSecondary={props.onClose}
            primary_button_disabled={!props.isValid}
            size="sm"
            onClickPrimary={() => {
                const input: Partial<Portfolio> = {  //TODO: Why partial here?
                    name: inputStateControl.getStringValueForKey("name"),
                    description: inputStateControl.getStringValueForKey("description"),
                    portfolio_type: inputStateControl.getStringValueForKey("portfolio_type") as PortfolioTypeEnum | undefined,
                };
                props.onSubmit(input);
                props.onClose();
            }}
        >
            <Row>
                <Col md={12}>
                    <RBSTextField
                        label="Name"
                        input_key="name"
                        prefill={prefill("name")}
                        validation_schemes={[ValidationSchemes.REQUIRED]}
                        input_state_control={inputStateControl}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <RBSTextField
                        label="Description"
                        input_key="description"
                        prefill={prefill("description")}
                        validation_schemes={[]}
                        input_state_control={inputStateControl}
                    />
                </Col>
            </Row>
            <Row>
    <Col md={12}>
        <RBSDropdown
            label="Portfolio Type"
            input_key="portfolio_type"
            prefill={prefill("portfolio_type") || PortfolioTypeEnum.MAIN}
            items={[
                { label: "Main", value: PortfolioTypeEnum.MAIN },
                { label: "Replenishment", value: PortfolioTypeEnum.REPLENISHMENT },
                { label: "Ramp Up", value: PortfolioTypeEnum.RAMP_UP },
            ]}
            input_state_control={inputStateControl}
            validation_schemes={[ValidationSchemes.REQUIRED]}
        />
    </Col>
</Row>
        </RBSModal>
    );
};
